<template>
  <div class="base_color">
    <div id="container" style="height: 900px">
     <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>
      <div class="clause" >
        <p style=" font-weight: bold; font-size: 16px;text-align:center">
          用途声明书
        </p>
        <p style=" font-weight: bold; font-size: 16px;text-align:center">
          上海浦东发展银行：
        </p>
        <p class="distance_50">
          本人在此承诺，本人向贵行申请的本笔贷款用于以本人为法定代 表人/负责人/实际控制人的经营。
        </p>
        <p class="distance_50">
          本人承诺决不会将贷款资金挪用于购买住房、投入商业房地产开 发、证券、期货、股本权益性投资等国家法律和金融法规明令禁止的 领域。
        </p>
        <p class="distance_50">
         浦发银行有权不定期核实本人所申请贷款资金使用情况，如经发 现贷款挪作他用，浦发银行有权提前收回贷款。特此声明。
        </p>
        <p class="distance_50">
          借款人姓名：
        </p>
        <p class="distance_50">
         证件号码：________
        </p>
        <p class="distance_50">
          日期：____ 年 ____ 月 _____ 日
        </p>
        <div ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FeildTwo',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color{
  width: 100%;
  height: 100%;
}
.crossBox{
  text-align: right;
}
.cross{
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.clause{
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 12px;
}
body {
  font-family: '微软雅黑';
}
.distance {
  text-align: left;

  /* margin-left: 10px; */
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  text-indent: 6px;
}
.distance_80 {
  text-align: left;

  /* margin-left: 10px; */
}
p {
  margin-bottom: 8px;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 10px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
</style>
